import { useMutation } from '@tanstack/react-query';

import type { MutationConfig } from '@/lib/react-query';
import { api, extractData } from '@/lib/treaty';

type DeleteImageOptions = {
  mutationConfig?: MutationConfig<typeof deleteImage>;
};

type DeleteImage = {
  projectId: string;
  imageIds: string[];
};

const deleteImage = ({ projectId, imageIds }: DeleteImage) => {
  return extractData(api.projects({ id: projectId }).images.batch.delete({ imageIds }));
};

export const useDeleteImage = ({ mutationConfig }: DeleteImageOptions = {}) => {
  return useMutation({ ...mutationConfig, mutationFn: deleteImage });
};
